import { render, staticRenderFns } from "./UpdateTime.vue?vue&type=template&id=4249f0b0&scoped=true"
import script from "./UpdateTime.vue?vue&type=script&lang=js"
export * from "./UpdateTime.vue?vue&type=script&lang=js"
import style0 from "./UpdateTime.vue?vue&type=style&index=0&id=4249f0b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4249f0b0",
  null
  
)

export default component.exports